import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger);

export default function(){
	const whereNextBlock = document.querySelector( '.where-next-block' )

	if ( whereNextBlock ){
		const text    = document.querySelector( '.where-next-block__text' )
		const teaser1 = document.querySelector( '.where-next-block__teaser-1' )
		const teaser2 = document.querySelector( '.where-next-block__teaser-2' )
		const teaser3 = document.querySelector( '.where-next-block__teaser-3' )


		let whereNextTL = gsap.timeline({
			scrollTrigger: {
				trigger: whereNextBlock,
				start: 'top bottom+=250px',
				//markers: true,
			}
		})

		whereNextTL
			.fromTo( text, { opacity: 0, x: '100px' }, { opacity: 1, x: 0 } )
			.fromTo( teaser1, { opacity: 0, x: '-100px', y: '-100px' }, { opacity: 1, x: 0, y: 0 }, '<' )
			.fromTo( teaser3, { opacity: 0, x: '100px', y: '100px' }, { opacity: 1, x: 0, y: 0 }, '<+=0.3' )
			.fromTo( teaser2, { opacity: 0, x: '-100px', y: '100px' }, { opacity: 1, x: 0, y: 0 }, '<+=0.3' )
	}
}